import React from 'react'

import BButton from 'components/Form/Fields/BButton'

const Checkout0 = ({t, next}) => (
  <div id='checkout0'>
    <h1>{t('Choose your secure checkout method')}</h1>

    <div>
      <div>
        <div>
          <h6>{t('Checkout as a customer')}</h6>

          <BButton yellow onClick={next}>{t('sign in to your profile')}</BButton>
        </div>
      </div>
      <div>
        <div>
          <h6>{t('Checkout as a guest')}</h6>

          <p>
            {t('You will have the opportunity to create an account and track your order once you complete your checkout.')}
          </p>

          <BButton yellow onClick={next}>{t('continue as a guest')}</BButton>
        </div>
      </div>
    </div>
  </div>
)

export default Checkout0
